import { createContext, ReactNode } from 'react'

import {
  SanityAuthStrings,
  SanityShopFormStrings,
} from '@data/sanity/queries/types/strings'

interface PrintShopFormStringsContextProps {
  authStrings: SanityAuthStrings
  shopFormStrings: SanityShopFormStrings
}

interface PrintShopFormStringsContextProviderProps {
  authStrings: SanityAuthStrings
  shopFormStrings: SanityShopFormStrings
  children: ReactNode
}

const emptyAuthStrings: SanityAuthStrings = {
  signupFirstName: '',
  signupFirstNamePlaceholder: '',
  signupFirstNameMissing: '',
  signupLastName: '',
  signupLastNamePlaceholder: '',
  signupLastNameMissing: '',
  signupPhoneNumber: '',
  signupPhoneNumberPlaceholder: '',
  signupPhoneNumberMissing: '',
  signupEmail: '',
  signupEmailPlaceholder: '',
  signupEmailMissing: '',
  signupPassword: '',
  signupPasswordPlaceholder: '',
  signupPasswordMissing: '',
  signupErrorMessage: [],
  signupAccountActivationMessage: [],
  signupSubmit: '',
  loginErrorMessage: [],
  loginFailedMessage: [],
  loginSubmit: '',
  passwordRecoveryErrorMessage: [],
  passwordRecoverySuccessMessage: [],
  passwordRecoverySubmit: '',
}

const emptyShopFormStrings: SanityShopFormStrings = {
  shopFormShopStepName: '',
  shopFormReviewStepName: '',
  shopFormShopSectionTitle: '',
  shopFormName: '',
  shopFormNamePlaceholder: '',
  shopFormNameMissing: '',
  shopFormSchool: '',
  shopFormSchoolPlaceholder: '',
  shopFormSchoolMissing: '',
  shopFormUserSectionTitle: '',
  shopFormLoginLink: '',
  shopFormStep1ErrorMessage: [],
  shopFormUploadPrint: '',
  shopFormUploadingPrint: '',
  shopFormUploadPrintTypeError: '',
  shopFormUploadPrintSizeError: '',
  shopFormUploadPrintError: '',
  shopFormPrintListEmpty: '',
  shopFormPrintTitleLabel: '',
  shopFormPrintTitlePlaceholder: '',
  shopFormOriginalPrintTitle: '',
  shopFormOptimizedPrintTitle: '',
  shopFormReviewStepUrlTitle: '',
  shopFormUrlCopyLinkButton: '',
  shopFormUrlCopyLinkButtonCopied: '',
  shopFormUploadStepFrontTitle: '',
  shopFormUploadStepBackTitle: '',
  shopFormReviewStepFrontTitle: '',
  shopFormReviewStepBackTitle: '',
  shopFormBackButton: '',
  shopFormNextButton: '',
  shopFormSkipUploadButton: '',
  shopFormEditSlotButton: '',
  shopFormPrintPreviewFrontLogo: '',
  shopFormPrintPreviewFrontImage: '',
  shopFormPrintPreviewFrontText: '',
  shopFormPrintPreviewBackLogo: '',
  shopFormPrintPreviewBackImage: '',
  shopFormPrintPreviewBackText: '',
  shopFormLogoPrintTypeTitle: '',
  shopFormImagePrintTypeTitle: '',
  shopFormLightPrintColorTitle: '',
  shopFormDarkPrintColorTitle: '',
}

export const PrintShopFormStringsContext =
  createContext<PrintShopFormStringsContextProps>({
    authStrings: emptyAuthStrings,
    shopFormStrings: emptyShopFormStrings,
  })

/**
 * The shop creation strings context provider.
 */
export const PrintShopFormStringsContextProvider = ({
  authStrings,
  shopFormStrings,
  children,
}: PrintShopFormStringsContextProviderProps) => (
  <PrintShopFormStringsContext.Provider
    value={{
      authStrings,
      shopFormStrings,
    }}
  >
    {children}
  </PrintShopFormStringsContext.Provider>
)
